import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { PromoModule } from './promos/promo.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { UserModule } from './user/user.module';
import { AuthModule } from './auth/auth.module';
import { HomeModule } from './home/home.module';
import { AuthGuardService } from './guards/auth-guard.service';
import { TagModule } from './tags/tag.module';
import { BookModule } from './book/book.module';
import { ReservationModule } from './reservation/reservation.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MailchimpModule } from './mailchimp/mailchimp.module';
import { TransactionModule } from './transaction/transaction.module';
import { ConsultationModule } from './consultation/consultation.module';
import { SettingsModule } from './settings/settings.module';
import { DragulaModule } from 'ng2-dragula';
import { RankingModule } from './ranking/ranking.module';
import { BannerModule } from './banner/banner.module';
import { CarouselModule } from './carousel/carousel.module';
import { NewsModule } from './news/news.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    CoreModule,
    HomeModule,
    DashboardModule,
    MailchimpModule,
    PromoModule,
    TagModule,
    BookModule,
    UserModule,
    ReservationModule,
    TransactionModule,
    SettingsModule,
    ConsultationModule,
    RankingModule,
    NewsModule,
    BannerModule,
    AuthModule,
    DragulaModule,
    CarouselModule,
    NgIdleKeepaliveModule.forRoot()
  ],
  providers: [AuthGuardService],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts